// Some imported reviews arrive with their body already wrapped in straight
// double quotes (e.g. `"They were friendly."`). Every card then wraps the
// content in its own quotes, producing doubled quotes like `"…friendly.""`.
// Strip a single surrounding pair so the UI's own curly quotes stand alone.
export const stripWrappingQuotes = (text) => {
  if (!text) return '';
  let out = String(text).trim();
  // Peel matched surrounding pairs (straight or curly), a few times, to handle
  // values that were wrapped more than once upstream.
  for (let i = 0; i < 3; i++) {
    const first = out[0];
    const last = out[out.length - 1];
    const isPair =
      (first === '"' && last === '"') ||
      (first === '“' && last === '”') ||
      (first === "'" && last === "'");
    if (out.length >= 2 && isPair) {
      out = out.slice(1, -1).trim();
    } else {
      break;
    }
  }
  // Some scraped content carries only a leading OR only a trailing quote (an
  // unmatched remnant, not a pair). Since every card supplies its own curly
  // quotes, strip any straight/curly quote chars still hugging either end.
  out = out.replace(/^["'“”]+\s*/, '').replace(/\s*["'“”]+$/, '');
  return out.trim();
};

// Curly quote characters, so render sites can wrap consistently:
//   {OPEN_QUOTE}{stripWrappingQuotes(content)}{CLOSE_QUOTE}
export const OPEN_QUOTE = '“';  // “
export const CLOSE_QUOTE = '”'; // ”
